import React, { useEffect, useState } from 'react';
import { INCOTERMS_LIST } from 'constants/incoterms';
import { MenuItem, SelectField, TextField } from 'material-ui';

/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  incoterms: any,
 *  changeCargo: Function }} value
 */
function Incoterms({
    incoterms = {}, cargoIndex, changeCargo,
}) {
    const [currentPortOrPlace, setCurrentPortOrPlace] = useState(incoterms && incoterms.place);

    useEffect(() => {
        setCurrentPortOrPlace(incoterms.place);
    }, [incoterms.place]);
    
    const handleChangeIncoterms = (value) => {
        const changes = [{
            field: 'incoterms.kind',
            value,
        }];

        if (!value) {
            changes.push({
                field: 'incoterms.place',
                value: undefined, 
            });
            setCurrentPortOrPlace(undefined);
        }

        changeCargo(changes);
    };

    return (
        <React.Fragment>
            <div 
                id='transportation'
                className='row'
            >
                <div className='column-left'>
                    INCOTERMS:
                </div>
                <div className='column-right' />
            </div>
            <div 
                id='transportation'
                className='row'
                style={{ display: 'flex' }}
            >
                <div className='col-xs-2'>
                    <SelectField
                        hintText='INCOTERMS'
                        floatingLabelText='INCOTERMS'
                        value={incoterms.kind || ''}
                        style={{ fontSize: '13px', width: '110px' }}
                        onChange={(_e, _i, v) => handleChangeIncoterms(v)}
                    >
                        <MenuItem value={null} primaryText='' />
                        {
                            INCOTERMS_LIST.map(item => <MenuItem key={item} value={item} primaryText={item} />)
                        }
                    </SelectField>
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={currentPortOrPlace || ''}
                        disabled={!incoterms.kind}
                        hintText='Port or plaсe'
                        floatingLabelText='Port or plaсe'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                        }}
                        onChange={e => changeCargo([{
                            field: 'incoterms.place',
                            value: e.target.value,
                        }])}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default Incoterms;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Incoterms.jsx